import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription, retry } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';


import { environment } from 'src/environments/environment';
import { PopupService } from 'src/app/services/popup.service';
import { WalletConnectService } from 'src/app/services/wallet-connect.service';
import { EventService } from 'src/app/services/event.service';
import { SwapStatus, convertNum } from 'src/app/shared/constants/app-enums';
import { ConnectComponent } from 'src/app/modals/connect/connect.component';
import { ClaimComponent } from 'src/app/modals/claim/claim.component';
import { SwapComponent } from 'src/app/components/swap/swap.component';


@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})

export class BannerComponent implements OnInit, OnDestroy {
  lang: any = localStorage.getItem('currentlang');

  private preSubscriptions: Subscription[] = [];
  private subscriptions: Subscription[] = [];
  modalRef?: BsModalRef;
  emailId = '';
  tokenSold = 0;
  totalTokens = 0;
  windowSize: number = 0;
  usdRaised = 0;
  currentStep = 0;
  selectedLanguage: any;

  connectInterval: any;
  usdtBal = 0;
  ethBal = 0;
  userClaimable: number = 0;
  userClaimableEth: number = 0;
  userStaked: number = 0;
  refreshId: any;
  refreshRate: number = 1000;
  dataLoaded: boolean = false;
  isSoldOut: boolean = true;
  futureToken: number = 0;
  salePrice: number = 0.0337;
  listPrice: number = 0.0337;
  liveCounter: any;
  isLive: boolean = true;
  // liveDate: Date = new Date('2023/03/29 14:53:20');
  // liveDate: Date = new Date('2023/05/24 12:00 UTC');
  claimMode: boolean = false;
  swapMode: string = 'native';
  isNative: boolean = true;
  isWert: boolean = false;
  SwapStatus = SwapStatus;
  timeInterval: any;
  @ViewChild(SwapComponent) swapComp: any;


  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private popupService: PopupService,
    private modalService: BsModalService,
    private walletConnectService: WalletConnectService,
    private eventService: EventService,

  ) {
    this.eventService.getLang().subscribe((val) => {
      this.lang = val || 'en';
    });
  }

  ngOnInit(): void {
    this.timeInterval = setInterval(() => this.setTimer(), this.refreshRate);

    this.preSubscriptions.push(this.eventService.getCounter().subscribe((val) => {
      this.liveCounter = val;
    }));

    this.preSubscriptions.push(this.eventService.getEvent('PRESALE-END').subscribe((mode: boolean) => {
      this.isLive = true;
      this.walletConnectService.activateSite();
      setTimeout(() => {
        if (this.isLive) this.getBalanceData();
        this.eventService.setCounter(this.currentStoreData.endDate);
      }, this.refreshRate);
    }));

    this.walletConnectService.activateSite();
    setTimeout(() => {
      if (this.isLive) this.getBalanceData();
    }, this.refreshRate);

  }

  getBalanceData() {
    const balanceData: any = this.walletConnectService.balanceData;
    // this.currentStep = balanceData.currentStep;
    this.tokenSold = balanceData.totalTokensSold;
    this.totalTokens = this.currentStoreData.maxAmount;
    this.ethBal = balanceData.nativeBal;
    this.usdtBal = balanceData.usdtBal;
    this.usdRaised = balanceData.usdRaised;
    this.userClaimable = balanceData.userClaimable;
    this.userClaimableEth = balanceData.ethClaimable;
    this.userStaked = this.walletConnectService.stakeData.userStaked;
    this.isSoldOut = true;
    this.dataLoaded = true;

    if (this.tokenSold >= this.walletConnectService.tokenomics[0].maxToken) {
      this.currentStep = 1;
    }

    this.getFutureToken();
    if (this.refreshId) clearTimeout(this.refreshId);
    this.refreshId = setTimeout(() => this.getBalanceData(), this.refreshRate);
  }

  connectModal(): void {
    this.modalRef = this.modalService.show(ConnectComponent, {
      class: 'modal-min modal-dialog-centered',
      backdrop: 'static'
    });
  }


  get tokenLeft() {
    let num = this.currentStoreData.maxToken - this.tokenSold;
    num = +((+num).toFixed(3));
    let nf = new Intl.NumberFormat('en-US');
    nf.format(num); // "1,234,567,890"
    return nf.format(num > 0 ? num : 0);
  }

  convertNum(amount: number) {
    return convertNum(amount);
  }

  get apy() {
    return this.walletConnectService.stakeData.apy;
  }

  disconnect(): void {
    this.walletConnectService.disConnectWallet();
  }

  openSwap(isNative: boolean = true, isWert: boolean = false): void {
    if (this.swapComp.wertMode) {
      this.popupService.messagePopup("warning", "",
        this.translate.instant("are_you_sure"),
        this.translate.instant("Confirm"),
        this.translate.instant("Cancel"))
        .then((result: any) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.swapComp.wertMode = false;
            this.swapMode = isNative ? 'native' : isWert ? 'card' : 'usdt';
            this.isNative = isNative;
            this.isWert = isWert;
          }
        });
    } else {
      this.swapMode = isNative ? 'native' : isWert ? 'card' : 'usdt';
      this.isNative = isNative;
      this.isWert = isWert;
    }
    setTimeout(() => this.swapComp.max(), 1000);
  }


  isCorrectChain() {
    return this.walletConnectService.isCorrectChain()
  }

  checkChain() {
    if (this.isCorrectChain()) {
      return true;
    } else {
      this.popupService.messagePopup(
        "info",
        this.translate.instant('wrong_chain', { chainName: this.eventService.isBsc ? environment.bsc.chainName : environment.eth.chainName }),
        this.translate.instant('change_network'))
        .then((res) => {
          if (res.isConfirmed) {
            this.walletConnectService.switchNetwork(this.eventService.isBsc ? environment.bsc.chainIdInt : environment.eth.chainIdInt);
          }
        });
      return false;
    }
  }

  checkEthChain() {
    if (this.walletConnectService.isEthChain()) {
      return true;
    } else {
      this.popupService.messagePopup(
        "info",
        this.translate.instant('wrong_chain', { chainName: environment.eth.chainName }),
        this.translate.instant('change_network'))
        .then((res) => {
          if (res.isConfirmed) {
            this.walletConnectService.switchNetwork(environment.eth.chainIdInt);
          }
        });
      return false;
    }
  }


  changeChain(): void {
    if (this.walletAddress) {
      this.walletConnectService.switchNetwork(!this.eventService.isBsc ? environment.bsc.chainIdInt : environment.eth.chainIdInt);
    } else {
      this.swapComp.swapToken = 0;
      this.eventService.isBsc = !this.eventService.isBsc;
      this.swapComp.swapTokenUpdate.next(this.swapComp.swapToken);
    }
  }

  getFutureToken() {
    let step = +this.currentStep;
    if (step != (this.walletConnectService.tokenomics.length - 1)) {
      this.futureToken = this.walletConnectService.tokenomics[step + 1].tokenUSDT;
    } else {
      this.futureToken = this.currentStoreData.tokenUSDT;
    }
    this.salePrice = this.currentStoreData.tokenUSDT;
  }

  get raisedPercent() {
    let percent = (this.usdRaised / this.currentStoreData.maxAmount) * 100;
    return (percent >= 100 ? 100 : percent) + '%';
  }

  get currentStoreData() {
    return this.walletConnectService.tokenomics[this.currentStep];
  }

  get walletAddress(): any {
    return this.walletConnectService.walletAddress;
  }

  get tokenPercent() {
    let percent = (this.tokenSold / this.currentStoreData.maxToken) * 100; //for presale
    return (percent >= 100 ? 100 : +(percent.toFixed(2))) + "%";
  }

  get tokenRemain() {
    return this.currentStoreData.maxToken - this.tokenSold;
  }

  get tokenName() {
    return environment.tokenName;
  }

  get isBsc() {
    return this.eventService.isBsc;
  }

  getReferralURL() {
    const data = {
      walletAddress: this.walletAddress,
      iid: environment.iidDashFx,
    }
  }

  ngOnDestroy(): void {
    for (const subscription of this.preSubscriptions) {
      subscription.unsubscribe();
    }

    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  async claim() {
    if (this.userClaimable !== 0 || this.checkChain()) {
      await this.walletConnectService.claim();
      this.modalRef = this.modalService.show(ClaimComponent, {
        class: 'modal-xs modal-dialog-centered',
        backdrop: 'static',
      });
    }
  }

  get status() {
    return this.walletConnectService.swapStatus;
  }

  setTimer() {
    if (this.tokenSold && this.tokenSold > 0) {
      this.eventService.setCounter(this.currentStoreData.endDate);
      clearInterval(this.timeInterval);
    }
  }

  async copy() {
    await this.popupService.messsageAlert('success', this.translate.instant("successCopy"));
  }

  get referUrl() {
    return this.walletConnectService.referUrl;
  }

  scrollToFn(section: string): void {
    this.eventService.scrollToFn(section);
  }

  claimStake(): void {
    if (this.userClaimable == 0 || !this.checkEthChain())
      return;
    this.walletConnectService.claimStake();
    this.modalRef = this.modalService.show(ClaimComponent, {
      class: 'modal-xs modal-dialog-centered',
      backdrop: 'static',
      initialState: { isStake: true }
    });
  }

  stakeInfo() {
    this.popupService.messagePopup(
      "info", this.translate.instant("stake_popup_info"))
  }
}
